import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { FeatureFlagsProvider } from "./providers/FeatureFlagsProvider";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

// After a new deployment Vite produces new content-hash filenames. If a user has
// the old page open, React.lazy dynamic imports will 404 → reload to pick up the new bundle.
window.addEventListener("unhandledrejection", (event) => {
  if (event.reason?.message?.includes("Failed to fetch dynamically imported module")) {
    window.location.reload();
  }
});

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <FeatureFlagsProvider>
          <App />
        </FeatureFlagsProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>
);
